import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {UserPermission} from '../admin.model';
import {AdminService} from '../admin.service';

interface MenuItem {
  caption: string,
  path: string,
  permissionKey: UserPermission,
  childItems?: MenuItem[]
}

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy {
  menuItems: MenuItem[];
  filteredMenuItems: MenuItem[];
  isLoggedIn: boolean;
  loggedInUserPermissions: UserPermission[];
  private loggedInSubscription: Subscription | undefined;
  private loggedInPermissionsSubscription: Subscription | undefined;

  constructor(private adminService: AdminService) {
    this.isLoggedIn = false;
    this.loggedInSubscription = undefined;
    this.loggedInPermissionsSubscription = undefined;
    this.loggedInUserPermissions = [];
    this.menuItems = [
      {
        caption: 'Smarticle Controlling',
        path: '/smarticle-controlling',
        permissionKey: UserPermission.SMARTICLE_CONTROLLING,
      },
      {
        caption: 'User Management',
        path: '/user-management',
        permissionKey: UserPermission.USER_MANAGEMENT,
        childItems: [
          {
            caption: 'Users',
            path: '/user-management/users',
            permissionKey: UserPermission.USER_MANAGEMENT
          },
          {
            caption: 'Groups',
            path: '/user-management/groups',
            permissionKey: UserPermission.USER_MANAGEMENT
          },
          {
            caption: 'Roles',
            path: '/user-management/roles',
            permissionKey: UserPermission.USER_MANAGEMENT
          }
        ]
      },
      {
        caption: 'Messages',
        path: '/messages',
        permissionKey: UserPermission.MESSAGES
      },
      {
        caption: 'Video Help',
        path: '/video-help',
        permissionKey: UserPermission.VIDEO_HELP
      },
      {
        caption: 'Onboarding Wizard',
        path: '/onboarding-wizard',
        permissionKey: UserPermission.ONBOARDING_WIZARD
      },
      {
        caption: 'Default Translations',
        path: '/default-translations',
        permissionKey: UserPermission.DEFAULT_TRANSLATIONS
      },
      {
        caption: 'Dashboard',
        path: '/dashboard',
        permissionKey: UserPermission.DASHBOARD
      },
      {
        caption: 'Website modules',
        path: '/website-modules',
        permissionKey: UserPermission.WEBSITE_MODULES
      },
      {
        caption: 'Clipping Dashboard',
        path: '/clipping-dashboard',
        permissionKey: UserPermission.CLIPPING_DASHBOARD
      },
      {
        caption: 'Profile',
        path: '/profile',
        permissionKey: UserPermission.PROFILE
      },
      {
        caption: 'Logout',
        path: '/logout',
        permissionKey: UserPermission.NONE
      }
    ];
    this.filteredMenuItems = [];
  }

  ngOnInit(): void {
    this.isLoggedIn = this.adminService.isLoggedIn();
    this.loggedInSubscription = this.adminService.loggedInObservable().subscribe(loggedIn => {
      this.isLoggedIn = loggedIn;
    });
    this.loggedInPermissionsSubscription = this.adminService.getProfileAsObservable().subscribe(permissions => {
      if (permissions) {
        this.loggedInUserPermissions = permissions.permissions;
        const newMenuItems : MenuItem[] = [];
        this.menuItems.forEach(menuItem => {
          if (menuItem.permissionKey === UserPermission.NONE || this.loggedInUserPermissions.includes(menuItem.permissionKey)) {
            if (menuItem.childItems && menuItem.childItems.length > 0) {
              // Check if the user have the right permissions to the child items
              let newChildMenuItems : MenuItem[] = [];
              menuItem.childItems.forEach(childItem => {
                if (childItem.permissionKey === UserPermission.NONE || this.loggedInUserPermissions.includes(childItem.permissionKey)) {
                  newChildMenuItems.push({...childItem});
                }
              });
              if (newChildMenuItems.length > 0) {
                newMenuItems.push({
                  caption: menuItem.caption,
                  path: menuItem.path,
                  permissionKey: menuItem.permissionKey,
                  childItems: newChildMenuItems
                })
              }
            } else {
              newMenuItems.push({...menuItem});
            }
          }
        });
        this.filteredMenuItems = newMenuItems;
      } else {
        this.filteredMenuItems = [];
      }
    });
  }

  ngOnDestroy() {
    if (this.loggedInSubscription) {
      this.loggedInSubscription.unsubscribe();
    }
    if (this.loggedInPermissionsSubscription) {
      this.loggedInPermissionsSubscription.unsubscribe();
    }
  }

}
